import { render, staticRenderFns } from "./EditNurse.vue?vue&type=template&id=64b0bb8e&scoped=true"
import script from "./EditNurse.vue?vue&type=script&lang=js"
export * from "./EditNurse.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "64b0bb8e",
  null
  
)

export default component.exports